<template>
  <div style="padding: 15px; background-color: #ddd">
    <hr />
    <v-layout align-center column justify-center row wrap>
      <v-flex xs12 md7>
        <h2>Solicitors Regulation Authority</h2>
        <div>
          Nigel Broadhead Mynard Solicitors is authorised and regulated by the
          <a
            href="http://www.sra.org.uk/"
            title="Solicitors Regulation Authority homepage"
            >Solicitors Regulation Authority</a
          >. NBM Solicitors are also bound by their
          <a
            href="http://www.sra.org.uk/solicitors/handbook/code/content.page"
            title="Solicitors Regulation Authority code of conduct"
            >code of conduct</a
          >
        </div>
        <ul>
          <li>
            Nigel Broadhead Mynard Solicitors - SRA registered no. 00061052
          </li>
          <li>
            NBM Massucco Shelbourne Solicitors - SRA registered no. 00210790
          </li>
        </ul>
        <p>NBM Solicitors {{ new Date().getFullYear() }}</p>
      </v-flex>
      <v-flex colMd="5">
        <!-- <h:form>
        <b:commandButton value="#{fragmentMessages.footer13}" oncomplete="$('.modalReportProblem').modal('show');" tooltip="#{fragmentMessages.footer14}" iconAwesome="bug" look="danger">
          <f:ajax execute="@form" render=":modalReportProblem" />
        </b:commandButton>
        </h:form>-->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
